// @ts-nocheck

import { v4 } from 'uuid';

// Request types
import Reporter from '../../../managers/reporter';
import requestTypes from '../requestTypes';

// object for storing reference to our promise-object
const promises = {};

const oldPromises = {};

// this function is called by native methods
// @param promiseId - id of the promise stored in global variable promises
export const callJs = (promiseId, data, error) => {
  const promise = promises[promiseId];
  try {
    console.debug(`%c bridge | callJs %O`, 'background: #616161; color: #fff;', { promiseId, data });
    promise.resolve({ data, error });

    // store promise in cache
    // remove reference to stored promise
    oldPromises[promiseId] = { request: promise.request, data, error };
    delete promises[promiseId];
  } catch (e) {
    Reporter.sendReport({
      message: 'Error in callJs callback android',
      request: promise?.request,
      error: e?.message,
      callJsData: data,
      callJsError: error,
      oldPromise: oldPromises[promiseId],
    });
  }
};

export const callNative = (request, payload) => {
  console.debug(`%c bridge | callNative %O`, 'background: #616161; color: #fff;', { request, payload });
  return new Promise((resolve, reject) => {
    // we generate a unique id to reference the promise later from native function
    const promiseId = v4();

    // save reference to promise in the global variable
    promises[promiseId] = { resolve, reject, request };

    try {
      if (request === requestTypes.REVIEW_CHECK) {
        if (window.Review) {
          window.Review.check(promiseId);
        } else {
          window.ReviewBetting.check(promiseId);
        }
      } else if (request === requestTypes.REVIEW_RATE) {
        if (window.Review) {
          window.Review.rate(promiseId);
        } else {
          window.ReviewBetting.rate(promiseId);
        }
      } else if (request === requestTypes.REVIEW_DISABLE) {
        if (window.Review) {
          window.Review.disable(promiseId);
        } else {
          window.ReviewBetting.disable(promiseId);
        }
      } else if (request === requestTypes.REVIEW_SHOULD_RESET) {
        if (window.Review) {
          window.Review.shouldReset(promiseId);
        } else {
          window.ReviewBetting.shouldReset(promiseId);
        }
      } else if (request === requestTypes.SHARE_BASE64_IMAGE) {
        // For Android we need to delete the first part (data:image/png;base64)
        // in order to just pass the raw data
        if (window.Share) {
          window.Share.share(payload.split(',')[1], promiseId);
        } else {
          window.ShareBetting.share(payload.split(',')[1], promiseId);
        }
      } else if (request === requestTypes.SHARE_TEXT) {
        if (window.Share) {
          window.Share.shareText(payload, promiseId);
        } else {
          window.ShareBetting.shareText(payload, promiseId);
        }
      } else if (request === requestTypes.AUTH_LOGIN) {
        window.AuthBetting.login(promiseId, payload);
      } else if (request === requestTypes.AUTH_LOGIN_AUTO) {
        if (window.Auth) {
          window.Auth.loginAuto(promiseId, payload);
        } else {
          if (window.AuthBetting.loginAuto) {
            window.AuthBetting.loginAuto(promiseId, payload);
          } else {
            window.AuthBetting.getToken(promiseId);
          }
        }
      } else if (request === requestTypes.AUTH_LOGOUT) {
        if (window.Auth) {
          window.Auth.logout(promiseId);
        } else {
          window.AuthBetting.logout(promiseId);
        }
      } else if (request === requestTypes.AUTH_GET_TOKEN) {
        if (window.Auth) {
          window.Auth.getToken(promiseId);
        } else {
          window.AuthBetting.getToken(promiseId);
        }
      } else if (request === requestTypes.AUTH_IS_AVAILABLE) {
        if (window.Auth) {
          window.Auth.isAvailable(promiseId);
        } else {
          window.AuthBetting.isAvailable(promiseId);
        }
      } else if (request === requestTypes.QR_IS_AVAILABLE) {
        window.QRValidator.isAvailable(promiseId);
      } else if (request === requestTypes.REQUEST_CAMERA_PERMISSION) {
        window.QRValidator.requestCameraPermission(promiseId);
      } else if (request === requestTypes.GET_CLIENT_INFOS) {
        window.App.getClientInfos(promiseId);
      } else if (request === requestTypes.IAP_OPEN) {
        window.InAppBrowser.openUrl(promiseId, payload);
      }
    } catch (err) {
      console.error(err);
      Reporter.sendReport({ message: 'Error in callNative plugin', request, error: err?.message });
      reject();
      delete promises[promiseId];
    }
  });
};
